import { LitElement, html, svg } from 'lit';

export class IconProductHighlightListing24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tekst med fremhevet bilde</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22 18H2M22 2H2M3.5 14h17a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 20.5 6h-17A1.5 1.5 0 0 0 2 7.5v5A1.5 1.5 0 0 0 3.5 14ZM14 22H2"></path></svg>`; }
}
if (!customElements.get('f-icon-product-highlight-listing24', IconProductHighlightListing24)) {
  customElements.define('f-icon-product-highlight-listing24', IconProductHighlightListing24);
}